import { useEffect, useState, useRef } from "react";

/**
 * Smoothly counts from 0 (or previous value) up to target.
 * Uses requestAnimationFrame with easing.
 */
export function useAnimatedNumber(target, duration = 900) {
  const [value, setValue] = useState(0);
  const fromRef = useRef(0);
  const startRef = useRef(0);

  useEffect(() => {
    if (target === null || target === undefined) return;
    const from = fromRef.current;
    startRef.current = performance.now();
    let raf;

    const tick = (now) => {
      const elapsed = now - startRef.current;
      const t = Math.min(1, elapsed / duration);
      // easeOutCubic
      const eased = 1 - Math.pow(1 - t, 3);
      const v = from + (target - from) * eased;
      setValue(v);
      if (t < 1) raf = requestAnimationFrame(tick);
      else fromRef.current = target;
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);

  return value;
}
